export default __webpack_public_path__ + "static/media/Nidi DArac.bfdf7bff.jpg";